import dayjs from 'dayjs'

import { convertTimezonedDateToIsoAtMidnight } from '../../../../../../../utils/date-helpers'

export const isBigCalendarSelectAllowed = ({
  start: _start,
  end: _end,
}: {
  start: Date
  end: Date
}): boolean => {
  const end = convertTimezonedDateToIsoAtMidnight(
    dayjs(_end).add(-1, 'minute').toDate(),
  )
  const start = convertTimezonedDateToIsoAtMidnight(dayjs(_start).toDate())

  const isNotSameView = dayjs(end).month() !== dayjs(start).month()

  if (isNotSameView) {
    return false
  }

  const dates = getDatesInBetween({ start, end })

  return dates.every((date) => isClickable(date))
}

export const isBigCalendarClickAllowed = ({
  date,
}: {
  date: Date
}): boolean => {
  return isClickable(date)
}

const isClickable = (_date: Date): boolean => {
  const date = convertTimezonedDateToIsoAtMidnight(dayjs(_date).toDate())

  const id = dayjs(date).format('DDMMYYYY')

  const { classList } = document.getElementById(id) || {}

  return classList ? classList.contains('rbc-select-available') : false
}

const getDatesInBetween = ({
  start,
  end,
}: {
  start: Date
  end: Date
}): Date[] => {
  const dates: Date[] = []

  let currentDate = start

  while (currentDate < end) {
    dates.push(currentDate)
    currentDate = dayjs(currentDate).add(1, 'day').toDate()
  }

  return dates
}
